import "./App.css";

// Pages
import Forside from "./Pages/Forside/Index.js";
import Boern from "./Pages/Faellesskaber/Boern/Index.js";
import JuniorTeen from "./Pages/Faellesskaber/JuniorTeen/Index.js";
import Kristendomskursus from "./Pages/Faellesskaber/Kristendomskursus/Index.js";
import Unge from "./Pages/Faellesskaber/Unge/Index.js";
import Andre from "./Pages/Faellesskaber/Andre/index.js";
import FaellesskabAlle from "./Pages/Faellesskaber/Alle/faellesskab-alle.js";
import Gudstjenesten from "./Pages/Gudstjeneste/Gudstjenesten/Index.js";
import KirkeligeHandlinger from "./Pages/Gudstjeneste/KirkeligeHandlinger/Index.js";
import Praedikner from './Pages/Gudstjeneste/Praedikner/index.js' 
import Kontakt from "./Pages/Kontakt/Index.js";
import DetViTrorPaa from "./Pages/OmOs/DetTrorViPaa/Index.js";
import HvemErVi from "./Pages/OmOs/HvemErVi/Index.js";
import LedelseAnsatte from "./Pages/OmOs/LedelseAnsatte/Index.js";
import Nav from "../src/Nav/index2.js";
import Kalender from "./Pages/Kalender/Kalender.js";
import BlogPage from "./Pages/Blog/Blog.js"
import BlogList from "./Pages/Blog/BlogList.js";
import Footer from './Footer/Footer.js'


import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

// Components
import ScrollToTop from "./Components/ScrollEffects/ScrollToTop.js";

function App() {

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return null;
}


  
  return (
    <main className="App">
      <Router>
        <Nav/>
        <ScrollToTop/>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Forside/>}></Route>
          {/* Fællesskaber */}
          <Route path="/faellesskab-alle" element={<FaellesskabAlle />}></Route>
          <Route path="/Andre" element={<Andre />}></Route>
          <Route path="/Boern" element={<Boern />}></Route>
          <Route path="/JuniorTeen" element={<JuniorTeen />}></Route>
          <Route
            path="/Kristendomskursus"
            element={<Kristendomskursus />}
          ></Route>
          <Route path="/Unge" element={<Unge />}></Route>
          {/* Gudstjeneste */}
          <Route path="/Gudstjenesten" element={<Gudstjenesten />}></Route>
          <Route
            path="/KirkeligeHandlinger"
            element={<KirkeligeHandlinger />}
          ></Route>
          <Route path="/Praedikener" element={<Praedikner/>}></Route>
          {/* Kontakt */}
          <Route path="/Kontakt" element={<Kontakt />}></Route>
          {/* Om os */}
          <Route path="/DetViTrorPaa" element={<DetViTrorPaa />}></Route>
          <Route path="/HvemErVi" element={<HvemErVi />}></Route>
          <Route path="/LedelseAnsatte" element={<LedelseAnsatte />}></Route>
          {/* Bloggen */}
          <Route path="/bloggen" element={<BlogList/>}></Route>
          <Route path="/bloggen/:id" element={<BlogPage/>}></Route>
          {/* Kalender */}
          <Route path="/Kalender" element={<Kalender />}></Route>
        </Routes>
      </Router>
    </main>
  );
}

export default App;
